<template>
  <v-app>
    <v-toolbar :elevation="2" shades color="black shades" id="wk_main_navbar">
      <div class="wk_logo_container">
        <router-link to="/">
          <LogoComponentRegistered/>
        </router-link>
      </div>

      <v-tabs
          fixed-tabs
          class="wk_main_nav"
          color="darken-1 "
          bg-color="transparent"
      >
        <v-tab v-if="loggedIn && (isAdmin || isSubsidiaryUser)" to="/collections">Collections</v-tab>
        <!--        <v-tab v-if="loggedIn" to="/colors">Colors</v-tab>-->
        <v-tab v-if="loggedIn && isAdmin" to="/finishes">Finishes</v-tab>
        <v-tab v-if="loggedIn" to="/stocks">Stocks</v-tab>
        <v-tab v-if="loggedIn" to="/producibility">Producibility</v-tab>
        <v-tab v-if="loggedIn && isAdmin" to="/users">Users</v-tab>
        <v-tab @click="logout">
          <v-icon icon="mdi-logout"></v-icon>
        </v-tab>
      </v-tabs>
    </v-toolbar>

    <v-main class="d-flex" style="min-height: 300px; margin-top: 64px">
      <router-view :key="this.$route.params"></router-view>
    </v-main>

    <!--v-main class="d-flex" style="min-height: 300px;" v-else>
      <Login v-on:login-success="isLoggedIn = $event"></Login>
    </v-main-->
  </v-app>
</template>

<style lang="scss">
@font-face {
  font-family: "Neue Montreal";
  font-style: normal;
  font-weight: normal;
  font-display: auto;
  src: url("https://abetlaminati.com/wp-content/uploads/2022/05/NeueMontreal-Regular.woff") format("woff");
}

@font-face {
  font-family: "Neue Montreal";
  font-style: normal;
  font-weight: bold;
  font-display: auto;
  src: url("https://abetlaminati.com/wp-content/uploads/2022/05/NeueMontreal-Bold.woff") format("woff");
}

@font-face {
  font-family: "Neue Montreal";
  font-style: italic;
  font-weight: normal;
  font-display: auto;
  src: url("https://abetlaminati.com/wp-content/uploads/2022/05/NeueMontreal-Italic.woff") format("woff");
}

@font-face {
  font-family: "Neue Montreal";
  font-style: italic;
  font-weight: bold;
  font-display: auto;
  src: url("https://abetlaminati.com/wp-content/uploads/2022/05/NeueMontreal-BoldItalic.woff") format("woff");
}

html,
body,
body * {
  font: normal 100%/1.5 "Neue Montreal", sans-serif;
  line-height: 1.3em;
}

header.v-toolbar .v-toolbar__content {
  width: 90%;
  margin: 0 auto;
  justify-content: space-between;
}

.wk_logo_container > a {
  display: block;
}

#wk_main_navbar {
  position: fixed;
  z-index: 9999;
}

#abet_logo {
  display: block;

  * {
    fill: white;
  }
}

.wk_main_nav .v-btn__content {
  color: white;
  text-decoration: none;
  font-weight: 700;
  text-transform: none;
  font-size: 16px;
}
</style>

<script>
import {mapGetters} from "vuex";
import axios from "axios";
import {API_URL} from "@/utils/const";
import authHeader from "@/services/data.service";
import store from "@/store";
import LogoComponentRegistered from "@/components/LogoComponentRegistered.vue";

export default {
  name: "Abet Toolkit",
  components: {LogoComponentRegistered},
  data: () => ({
    snackbar: false,
    text: "",
  }),
  computed: {
    ...mapGetters("auth", ["loggedIn"]),
    ...mapGetters("auth", ["token"]),
    ...mapGetters("auth", ["isAdmin"]),
    ...mapGetters("auth", ["isSubsidiaryUser"]),
    ...mapGetters("auth", ["isSalesUser"])
  },
  methods: {
    logout() {
      if (!this.loggedIn) {
        return;
      }

      axios.get(API_URL + `auth/logout`, {headers: authHeader()});

      this.$store
          .dispatch("auth/logout")
          .then(() => {
            this.$router.push({path: "/login"});
          })
          .catch(() => {
          });
    },
  },
  async mounted() {
    if (this.loggedIn) {
      await store.dispatch("auth/role");
    }
  }
};
</script>
